import React, { useRef } from 'react';
// components
import Select from '../../common/Select';
import Search from '../../common/Search';
import DatePicker from './DatePicker';
import FormCheckBox from '../../common/Input/FormCheckBox';
// utils
import largeArrowWhiteDown from '../../../assets/icons/largeArrowWhiteDown.svg';
import {
  Container,
  Content,
  SelectItems,
  ClearFilters,
  Toggle,
  IconContainer,
  Icon,
  FlexRow,
  CheckBoxsContainer,
  SearchSection,
  ClearButton,
} from './filterHeaderStyle';
import ReactResizeDetector from 'react-resize-detector';
import { useTranslation } from 'react-i18next';

interface IProps {
  state: any;
  toggleSelected: (id: number, key: string) => void;
  removeAllSelected: (key: string) => void;
  clearAllFilters: () => void;
  handleDayClick: (day: Date, modifiers: any) => void;
  setNumOfActiveFilters?: React.Dispatch<number>;
  numOfActiveFilters: number;
  searchValue: string;
  debouncedValue: string;
  clearSearchValue: () => void;
  handleSeachStringChange: (e: any) => void;
  onHeightChange?: (height: number) => void;
  isFiltersOpen: boolean;
  setIsFiltersOpen: (isOpen: boolean) => void;
  handleCheckboxesChange: (values: any) => void;
  isShowSearchSection?: boolean;
  initialMonth?: Date;
  disabledDays?: any[];
}

const FilterHeader: React.FC<IProps> = ({
  state,
  toggleSelected,
  removeAllSelected,
  clearAllFilters,
  handleDayClick,
  numOfActiveFilters,
  searchValue,
  debouncedValue,
  clearSearchValue,
  handleSeachStringChange,
  onHeightChange,
  isFiltersOpen,
  setIsFiltersOpen,
  handleCheckboxesChange,
  isShowSearchSection = true,
  initialMonth,
  disabledDays,
}) => {
  const filterContentElement = useRef(null);
  const { t } = useTranslation();

  const clearFilters = () => {
    clearAllFilters();
    clearSearchValue();
  };

  const onFiltersHeightChange = (height: number) => {
    onHeightChange && onHeightChange(height);
  };

  return (
    <Container ref={filterContentElement} isOpen={isFiltersOpen} isHidden={false}>
      <ReactResizeDetector
        handleHeight
        onResize={(width, height) => onFiltersHeightChange(height)}
      >
        {() => (
          <Content>
            <FlexRow>
              <SelectItems>
                {Object.keys(state).map((key: string, idx: number) => {
                  const { title, options, isFilterActive, type } = state[key];
                  const props = {
                    key: idx,
                    keyName: key,
                    title,
                    list: options,
                    removeAllSelected,
                    isFilterActive,
                    initialMonth,
                    disabledDays,
                  };
                  if (type === 'date') {
                    return (
                      <DatePicker {...props} handleDayClick={handleDayClick} />
                    );
                  } else if (type === 'dropdown') {
                    if (key === 'city' || key === 'community') {
                      return (
                        <Select
                          {...props}
                          hasFilterInput
                          guestTitle={
                            (title === 'admin.table.cityOfSalon' && title) ||
                            (title === 'admin.table.assignToCommunity' &&
                              'admin.table.community')
                          }
                          toggleItem={toggleSelected}
                        />
                      );
                    } else if (!key.includes('mobile')) {
                      return <Select {...props} toggleItem={toggleSelected} />;
                    }
                  }
                  return null;
                })}
              </SelectItems>
              {isShowSearchSection && (
                <SearchSection>
                  <Search
                    searchValue={searchValue}
                    clearSearchValue={clearSearchValue}
                    handleSeachStringChange={handleSeachStringChange}
                    debouncedValue={debouncedValue}
                  />
                </SearchSection>
              )}
              <ClearButton onClick={clearAllFilters}> {t('filters.clean')}</ClearButton>
            </FlexRow>
            {state.checkbox_options ? (
              <CheckBoxsContainer>
                <span>{t('admin.table.filterOnly')}</span>
                <FormCheckBox
                  checkBoxesList={state.checkbox_options.options}
                  selectedList={state.checkbox_options.selectedOptions}
                  onChange={handleCheckboxesChange}
                />
              </CheckBoxsContainer>
            ) : null}
          </Content>
        )}
      </ReactResizeDetector>
      {/* <Toggle onClick={() => setIsFiltersOpen(!isFiltersOpen)}>
				<IconContainer>
					<Icon src={largeArrowWhiteDown} alt="arrow up" isOpen={isFiltersOpen} />
				</IconContainer>
			</Toggle> */}
    </Container>
  );
};

export default FilterHeader;
